export const compactPermissions = (permissions = null) => {
  const result = {};
  (permissions || []).forEach(({ name, resourceName }) => {
    result[resourceName] = result[resourceName] || [];
    result[resourceName].push(name);
  });
  return {
    has: (resourceName, permission) => {
      return (result[resourceName] || []).includes(permission);
    },
    permissions: result,
  };
};

export default Object.freeze([
  'User',
  'MasterData',
  'Job',
  'CAP',
  'ReportReview',
  'ReportGeneration',
  'OfflineApp',
]);
